import React from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  emoji: '💥',
  text: 'Tu cuerpo te pasa factura y 5 días antes de que te venga empezás con dolor de ovarios, espalda baja, cólicos o hinchazón.'
}, {
  emoji: '🧠',
  text: 'Tu cabeza no para y antes del periodo sobrepensás más, te agarra ansiedad y te cuesta dormir.'
}, {
  emoji: '💞',
  text: 'Tu relación se resiente porque esos días estás más sensible, irritable o interpretás todo más intenso con tu novio.'
}, {
  emoji: '🍫',
  text: 'Tu comida se desordena porque te agarran antojos fuertes, comés por ansiedad y después te sentís culpable.'
}, {
  emoji: '📚',
  text: 'Tu productividad se cae porque querés rendir en el trabajo o en la facultad, pero el dolor, el cansancio y el malestar te tiran abajo.'
}];
export function EmpathySection() {
  return <section className="py-20 bg-cream px-4 sm:px-6 lg:px-8" data-id="element-45">
      <div className="max-w-6xl mx-auto" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-47">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark" data-id="element-48">
            Este kit es para vos si…
          </h2>
          <div className="w-24 h-1 bg-burgundy mx-auto mt-6" data-id="element-49"></div>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-50">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-4" data-id="element-51">
            {painPoints.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-burgundy flex items-start space-x-4 hover:shadow-md transition-shadow" data-id="element-52">
                <span className="text-2xl flex-shrink-0" data-id="element-53">{point.emoji}</span>
                <p className="text-gray-700 font-medium leading-relaxed" data-id="element-54">
                  {point.text}
                </p>
              </motion.div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative hidden lg:block" data-id="element-55">
            <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=800&q=80" alt="Mujer pensativa" className="rounded-2xl shadow-xl object-cover h-[600px] w-full filter grayscale-[20%]" data-id="element-56" />
            <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-black/10" data-id="element-57"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}